export enum DOCUMENT_TYPE_TYPES {
  'FACE' = 'FACE',
  'Progress' = 'Progress',
  'Discharge' = 'Discharge',
  'Assessment' = 'Assessment',
  'Increase' = 'Increase',
  'Decrease' = 'Decrease',
  'POS' = 'POS',
  'IFSP' = 'IFSP',
  'Other' = 'Other',
}
